import script from "./EffectGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectGallery.vue?vue&type=script&setup=true&lang=ts"

import "./EffectGallery.vue?vue&type=style&index=0&id=1320d6e2&lang=scss"

const __exports__ = script;

export default __exports__